<div class="form-view-container">
    <h2 class="fw-bold mb-3 text-center text-light">Create New Password</h2>
    <p class="form-instruction text-center mb-4" id="passwordRequirement">Your new password must be at least 8 characters long.</p>
    <form (ngSubmit)="resetPassword()">
        <!-- New Password Input -->
        <div class="form-floating mb-3">
            <input type="password" class="form-control" id="newPassword" name="newPassword" placeholder="NEW PASSWORD"
                autocomplete="new-password" [ngModel]="newPassword()" (ngModelChange)="newPassword.set($event)"
                aria-describedby="passwordRequirement passwordStrengthStatus" required>
            <label for="newPassword">NEW PASSWORD</label>
        </div>

        <!-- Confirm New Password Input -->
        <div class="form-floating mb-2">
            <input type="password" class="form-control" id="confirmNewPassword" name="confirmNewPassword"
                placeholder="CONFIRM NEW PASSWORD" autocomplete="new-password" [ngModel]="confirmNewPassword()"
                (ngModelChange)="confirmNewPassword.set($event)"
                [attr.aria-invalid]="newPassword().length > 0 && confirmNewPassword().length > 0 && !passwordsMatch() ? 'true' : 'false'"
                aria-describedby="passwordMismatchAlert" required>
            <label for="confirmNewPassword">CONFIRM NEW PASSWORD</label>
        </div>

        <!-- Password Strength Indicator -->
        @if (newPassword().length > 0) {
        <div class="d-flex align-items-center mb-3" id="passwordStrengthStatus" role="status" aria-live="polite"
            [attr.aria-label]="'Password strength: ' + newPasswordStrength().text">
            <div class="flex-grow-1 d-flex gap-1" style="height: 6px;" aria-hidden="true">
                <div class="strength-bar" [class]="getStrengthBarClass(1, newPasswordStrength().level)">
                </div>
                <div class="strength-bar" [class]="getStrengthBarClass(2, newPasswordStrength().level)">
                </div>
                <div class="strength-bar" [class]="getStrengthBarClass(3, newPasswordStrength().level)">
                </div>
                <div class="strength-bar" [class]="getStrengthBarClass(4, newPasswordStrength().level)">
                </div>
            </div>
            <small class="ms-3 fw-bold" [class]="getStrengthClass(newPasswordStrength().level)">
                {{ newPasswordStrength().text }}
            </small>
        </div>
        }
        @if (newPassword().length > 0 && confirmNewPassword().length > 0 && !passwordsMatch()) {
        <div class="text-danger small mt-2 ps-2" id="passwordMismatchAlert" role="alert" aria-live="assertive">Passwords do not match.</div>
        }

        <!-- Submit Button -->
        <div class="mt-4">
            <button type="submit"
                class="btn btn-danger w-100 d-flex align-items-center justify-content-center btn-submit"
                style="height: 4rem;" [disabled]="!passwordsMatch() || newPassword().length < 8"
                aria-label="Reset password" title="Reset Password">
                <span class="fw-bold fs-5 text-white">RESET PASSWORD</span>
            </button>
        </div>
    </form>
    <div class="mt-5 text-center small login-links">
        <a href="#" (click)="$event.preventDefault(); changeView.emit('login')" role="button"
            class="fw-bold text-decoration-none text-uppercase login-link">Back to Sign In</a>
    </div>
</div>